import { render } from "./DiskSizeSelection.vue?vue&type=template&id=8baa51d6&scoped=true"
import script from "./DiskSizeSelection.vue?vue&type=script&lang=js"
export * from "./DiskSizeSelection.vue?vue&type=script&lang=js"

import "./DiskSizeSelection.vue?vue&type=style&index=0&id=8baa51d6&scoped=true&lang=less"

import exportComponent from "/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8baa51d6"]])

export default __exports__